import API from '../api'
import getUrl from './paths'
import convertPagableData from '../convertPagableData'

export const getAllBlogApi = (page = 0, blogFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllBlog, { page, ...blogFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((err) => reject(err))
    })
    
export const getBlogByIdApi = (contentId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getBlogById, { contentId, removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
